import { GUIDE_TYPE_RECOMMEND } from '@/configs/guide';

export const DEFAULT_SHOP_STATUS = {
  // 资质图片
  picInfos: [],
  uploadMessageVisible: false,
  trialOpenType: null,
  trialOpenDay: null,
  openDay: null,
  trialMinDate: null,
  trailMaxDate: null,
  openMinDate: null,
  openMaxDate: null,
  softOpenModalVisible: false,
  reportType: null,
  closeReasonEnum: [],
  clearanceReason: '',
  clearanceOtherReason: '',
  // 核实途径
  verificationMethod: '',
  verificationOtherMethod: '',
};

export const DEFAULT_RELATION_INFO = {
  needSubmit: false, // 为了 联动是否需要输入文案、提交按钮的 disabled 等状态
  source: '', // 按何种 id 搜索的相关关系
  shopInfoList: [], // 根据 idList 批量请求的门店数据; 入参是 dpId 还是 mtId，取决于 source 字段；且第一项为主门店
  newMainId: '',
  shopList: [], // 按名称搜索得到的门店列表
  shopListPaginationInfo: {
    currentPage: 0,
    totalItems: 0,
  },
  shopListRepeat: [],
  mergeShopList: [], // 将要被合并的门店的列表
  splitShopInfo: {}, // 将要被拆分的门店信息
};

export const DEFAULT_SHOP_RELATION_INFO = {
  shopRelationList: [],
  yellowTips: null,
  auditing: false,
};

export const DEFAULT_GROUPS_INFO = {
  groupShopInfoList: [], // 根据 shopId 批量请求得到的连锁门店数据, 此处 shopId 就是 dpId
  mergeGroupsList: [], // 将要被关联的门店列表
  picUrls: [],
  comment: '',
};

export const DEFAULT_GUIDE_INFO = {
  guideList: [],
  guideType: GUIDE_TYPE_RECOMMEND,
  guideCurrentItem: null,
  guideRoads: '',
  guideSubwayEntry: {},
};

export const DEFAULT_WEDDING_INFO = {
  weddingType: '',
  phoneList: [],
  businessHoursObj: null,
  cateId: [],
  backCateName: [],
};
